module.exports = __webpack_public_path__ + "static/media/bigDataApplication.caf1c18e.png";